<template>
  
</template>

<script>
export default {
    name:'cl-message'
}
</script>

<style>

</style>